import React, { useState, useEffect } from "react";
import "./Chat.css";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import io from "socket.io-client";
import InfoBar from "../InfoBar/InfoBar";
import Messages from "../Messages/Messages";
import Input from "../Input/Input";
import TextContainer from "../TextContainer/TextContainer";

let socket;

// function useQuery() {
//   return new URLSearchParams(useLocation().search);
// }

const Chat = () => {
  const [name, setName] = useState("");
  const [room, setRoom] = useState("");
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [users, setUsers] = useState([]);

  const location = useLocation();
  const BASEURL = "https://jtchat.herokuapp.com/";
  // const query = useQuery();

  useEffect(() => {
    const { name, room } = queryString.parse(location.search);
    // const name = query.get("name");
    // const room = query.get("room");
    socket = io(BASEURL, {
      cors: {
        origin: "*",
        // withCredential: true,
        // methods: ["GET", "POST"],
      },
    });

    setName(name);
    setRoom(room);

    socket.emit("Join", { name, room }, () => {});
    console.log(socket);

    return () => {
      socket.emit(" disconnect");
      socket.off();
    };
  }, [BASEURL, location.search]);

  // message handling useEffect
  useEffect(() => {
    socket.on("message", (message) => {
      setMessages([...messages, message]);
    });
    socket.on("roomData", (users) => {
      setUsers(users.users);
    });
  }, [messages]);

  // FUNCTION FOR SENDING MESSAGES
  const sendMessage = (event) => {
    event.preventDefault();
    if (message) {
      socket.emit("sendMessage", message, () => {
        setMessage("");
      });
    }
  };

  console.log("message is: ", message);
  console.log("array is", messages);
  console.log("users is", users);

  return (
    <div className="chat-outer-container">
      <div className="chat-container">
        <InfoBar chatRoom={room} />
        <Messages messages={messages} name={name} />
        <Input
          message={message}
          setMessage={setMessage}
          sendMessage={sendMessage}
        />
      </div>
      <TextContainer users={users} />
    </div>
  );
};

export default Chat;
